import * as A from 'fp-ts/lib/Array'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import * as S from 'fp-ts/lib/string'

import { ApolloRichText, ContentfulImage } from '@ecomm/contentful-components'
import type { Countries, Country, LeadGenForm } from '@ecomm/footer-data'

export const toOffersData = (
  leadGenerationForm: LeadGenForm,
  handleEmailSubmit: (email: string) => void,
  isSuccess: boolean,
  defaultEmail: string
) => {
  const inputLabel = leadGenerationForm.title
  const placeHolder = leadGenerationForm.formCollection.items[0]?.placeholder
  const buttonText = leadGenerationForm.button.text
  const ctaContent = leadGenerationForm.note?.json ? (
    <ApolloRichText json={leadGenerationForm.note?.json} />
  ) : null
  // TODO: Retrieve from CTFL instead of hard coding it
  const errorMsg = 'Please enter a valid email address.'
  const success = {
    message: 'Thanks! Keep an eye on your email for tips, offers and more.',
    title: ''
  }
  const offersDataSpec = {
    buttonText,
    ctaContent,
    defaultEmail,
    errorMsg,
    inputLabel,
    onEmailSubmit: handleEmailSubmit,
    placeHolder,
    title: inputLabel
  }

  return {
    ...offersDataSpec,
    success: isSuccess ? success : null
  }
}
